// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"102e16d8","96":"71a3fb9a","233":"be510eca","453":"455cf202","469":"d43e35f1","906":"8313db5a","997":"ed4eb328"}[chunkId] + ".chunk.js";
};